<template>
    <v-card class="mb-2">
        <v-card-title>Firma</v-card-title>
        <my-upload field="firma"
                   @crop-success="cropSuccess"
                   @crop-upload-success="cropUploadSuccess"
                   @crop-upload-fail="cropUploadFail"
                   v-model="show"
                   :width="453"
                   :height="181"
                   lang-type="es-MX"
                   :url="url"
                   :headers="headers"
                   img-format="png"></my-upload>
        <v-img :src="imgDataUrl" height="200px" contain>
        </v-img>
        <v-card-actions>
            <v-btn flat @click="toggleShow" color="primary">Cambiar Firma</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
  import myUpload from 'vue-image-crop-upload'
  import { mapState } from 'vuex'

  export default {
    name: 'FirmaUsuario',
    components: {myUpload},
    data: () => ({
      url: process.env.API_URL + '/upload-firma',
      show: false,
      imgDataUrl: '',
      imgChange: false
    }),
    created () {
      const BASE_URL = this.$store.getters.getBaseURL
      const img = new Image()

      img.onload = () => {
        this.imgDataUrl = this.userImage
      }
      img.onerror = () => {
        this.imgDataUrl = BASE_URL + '/uploads/00000000.png?' + (new Date()).getTime()
      }
      img.src = this.userImage
    },
    computed: {
      ...mapState({
        headers: state => {
          return {
            Authorization: 'Bearer ' + state.auth.token
          }
        },
        userImage: state => {
          return state.user.profile.firma + '?' + (new Date()).getTime()
        }
      })
    },
    methods: {
      toggleShow () {
        this.show = !this.show
      },
      /**
       * crop success
       *
       * [param] imgDataUrl
       * [param] field
       */
      cropSuccess (imgDataUrl, field) {
        console.log('-------- crop success --------')
        this.imgDataUrl = imgDataUrl
      },
      /**
       * upload success
       *
       * [param] jsonData  server api return data, already json encode
       * [param] field
       */
      cropUploadSuccess (jsonData, field) {
        console.log('-------- upload success --------')
        console.log(jsonData)
        console.log('field: ' + field)
      },
      /**
       * upload fail
       *
       * [param] status    server api return error status, like 500
       * [param] field
       */
      cropUploadFail (status, field) {
        console.log('-------- upload fail --------')
        console.log(status)
        console.log('field: ' + field)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/FirmaUsuario.vue